import React from 'react'
import PropTypes from 'prop-types'

import Icon from '../Icons'
import { getAssetLink } from '../../helpers/get-asset-link'
import ImageField from '../FormLegacy/FormFieldsV2/ImageField'

const ImagesPicker = ({ value, imageLimit, onChange }) => {
  const [images, setImages] = React.useState(value || [])

  React.useEffect(() => {
    setImages(value)
  }, [value])

  const addImage = (image) => {
    const newImages = [...images, image]
    setImages(newImages)
    onChange(newImages)
  }

  const removeImage = (index) => {
    const newImages = [...images]
    newImages.splice(index, 1)
    setImages(newImages)
    onChange(newImages)
  }

  return (
    <div className="images-picker">
      {images.length > 0
        ? images.map((item, index) => (
            <div
              key={`${item}_${index}`}
              className="images-picker__image"
              style={{
                backgroundImage: `url(${item.image ? item.image : getAssetLink({ path: 'chitown-images/booking', file: item })})`,
              }}
            >
              <button className="remove-button" onClick={() => removeImage(index)}>
                <Icon icon="cross" fill="#ffffff" />
              </button>
            </div>
          ))
        : null}

      {images.length < imageLimit ? (
        <div className="images-picker__upload">
          <ImageField
            name={'image'}
            imageRatio={4 / 3}
            onChange={(e) => addImage(e.target.value)}
            value={{ image: undefined }}
            additionalClass={'field-image-extra'}
          />
          <span className="image-picker__label">Upload Photo</span>
        </div>
      ) : null}
    </div>
  )
}

ImagesPicker.propTypes = {
  value: PropTypes.array,
  imageLimit: PropTypes.number,
  onChange: PropTypes.func,
}

export default ImagesPicker
